import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

const About = () => {
  // const [isExpanded, setIsExpanded] = useState(false);
  const [isExpanded2, setIsExpanded2] = useState(false);
  // const navigate = useNavigate();

  return (
    <div className="text-gray-800 font-sans">
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center text-white text-center px-4 overflow-hidden">
        {/* Background image layer */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url("https://res.cloudinary.com/dxdvcplbl/image/upload/v1754842640/DJI_20250810155011_0041_D-min_rpyzkh.jpg")`,
          }}
        ></div>

        {/* Overlay */}
        <div className="absolute inset-0 bg-black opacity-50"></div>

        {/* Foreground content */}
        <div className="relative z-10 max-w-4xl">
          <h1 className="text-3xl md:text-5xl font-bold leading-snug">
            "RGCC is a scenic 9-hole premier riverside golf destination where
            Rangpur’s golfing legacy meets luxury and leisure."
            {/* <br /> */}
            {/* premier private, resort, */}
            {/* <br /> */}
            {/* and daily fee golf */}
            {/* <br /> */}
            {/* courses throughout */}
            {/* <br /> */}
            {/* Bangladesh */}
          </h1>
        </div>
      </section>

      {/* Intro Section */}

      <section className="py-16 px-4 md:px-20 bg-white grid md:grid-cols-2 gap-10">
        <img
          src="https://res.cloudinary.com/dxdvcplbl/image/upload/v1754842629/DJI_20250810155606_0047_D-min_vmsho6.jpg"
          alt="Golf Course"
          className="w-full h-auto rounded-lg"
        />
        <div>
          <h2 className="text-xl font-bold mb-4">
            Rangpur Golf & Country Club
          </h2>
          <div
            className={`overflow-hidden transition-all duration-500 ease-in-out ${
              isExpanded2 ? "max-h-[1000px]" : "max-h-[6em]"
            }`}
          >
            <p className="">
              Welcome to Rangpur Golf & Country Club (RGCC), a distinguished
              golfing destination in northern Bangladesh. Since its inception in
              the early 1990s by Major General AMSA Amin, our club has grown
              into a vibrant hub for golf enthusiasts, fostering a spirit of
              camaraderie and sporting excellence. The most pivotal chapter in
              the history of RGCC was written under the extra-ordinary
              leadership of the present president Major General Mohammad Kamrul
              Hasan, GOC 66 Inf Div and Area Comd, Rangpur Area. His vision and
              dedication have been the driving forces behind the remarkable
              transformation of this beautiful golf course. Recognizing the
              potential of the club, Major General Kamrul Hasan initiated a
              comprehensive development plan and elevated RGCC to a newer height
              within a very short span of time. Only his personal interest has
              made it possible to build an iconic and aesthetic clubhouse,
              adjusting the courses, enhancing the facilities, and introducing
              modern amenities to ensure an unparallel experience for members.
              The unwavering commitment of our present president Major General
              Kamrul Hasan has not only enriched the club’s infrastructure but
              also strengthened the sporting community, attracting more members
              and hosting numerous prestigious tournaments. Under his able
              guidance, RGCC has become a beacon of excellence and innovation in
              northern Bangladesh’s golfing landscape, making it a proud symbol
              of luxury, tradition, and progress. Thanks to the respected
              President for his remarkable and exceptional leadership. His
              impeccable contribution includes exquisitely maintained greens,
              scenic views along the Ghaghat river, and top-tier facilities
              including premium restaurant, luxurious lounge, resourceful pro
              shop, time worthy and effective driving range, an global standard
              carparking, landscaping in front of golf house and professional
              coaching services. Since joining the Golf Federation in 2016, RGCC
              has hosted over 70 tournaments, with a growing and passionate
              membership of 245 dedicated golfers. Join us at RGCC to experience
              the legacy of outstanding leadership and to be part of a thriving
              community that is redefining golf in northern Bangladesh.
            </p>
          </div>
          <div className="flex gap-4">
            <button
              onClick={() => setIsExpanded2(!isExpanded2)}
              className="text-black mt-4 text-sm underline hover:text-black/70 transition-colors duration-300"
            >
              {isExpanded2 ? "READ LESS" : "READ MORE"}
            </button>
          </div>
        </div>
      </section>

      {/* Community Section */}
      {/* <section
        className="relative bg-cover bg-center h-[50vh] text-black px-4 flex items-center"
        style={{
          backgroundImage: `url("https://res.cloudinary.com/dxdvcplbl/image/upload/v1754842632/DJI_20250810161007_0208_D-min_tltyl6.jpg")`,
        }}
      >
        <div className="bg-lime-400 bg-opacity-80 p-6 rounded-lg max-w-lg ml-4">
          <h3 className="text-xl font-bold mb-2">Friendly Community</h3>
          <div
            className={`overflow-hidden transition-all duration-500 ease-in-out ${
              isExpanded ? "max-h-[500px]" : "max-h-[3em]"
            }`}
          >
            <p>
              Enjoy the perfect mix of nature and modern comfort at our top golf
              club, where beautiful green fairways and modern facilities offer a
              great experience for all golfers. Meet friendly members in a
              family-friendly community and relax with delicious food at our
              nice restaurant—an ideal place to spend time with friends, family,
              and other golf lovers.
            </p>
          </div>
          <button
            className="mt-4 text-sm text-black underline hover:text-black/70 transition-colors duration-300"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? "READ LESS" : "READ MORE"}
          </button>
        </div>
      </section> */}

      {/* Leadership Team Section */}
      {/* <section className="py-16 px-4 md:px-20 bg-gray-50">
        <h2 className="text-2xl font-bold mb-10 text-center">
          RGCC Leadership Team
        </h2>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10">
          {[
            {
              name: "Maj Gen Mohammad Kamrul Hasan, SGP, SUP, ndc, hdmc, psc",
              title: "President",
              image:
                "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754892864/TF00001_passport-min_f4iuzp.jpg",
            },

            {
              name: "Brig Gen Emranul Hasan, BGMS",
              title: "Vice President",
              image:
                "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754933491/no-profile_ha50x4.jpg",
            },
            {
              name: "Col Muhammad Rubayat Zamil, BSP",
              title: "Golf Capt",
              image:
                "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754933491/no-profile_ha50x4.jpg",
            },
            {
              name: "Lt Col Arif Billah, psc",
              title: "Member Secretary",
              image:
                "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754933491/no-profile_ha50x4.jpg",
            },
            {
              name: "Maj Md Faysal Hasan Khan, SUP",
              title: "Asst Member Secretary",
              image:
                "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754933491/no-profile_ha50x4.jpg",
            },
            {
              name: "Capt Nasreen Haque Boby",
              title: "Lady Golf Capt",
              image:
                "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754933491/no-profile_ha50x4.jpg",
            },
            // { name: "John Reti", title: "Lady Golf Captain", image: img2 },
          ].map((member, i) => (
            <div
              key={i}
              className="text-center border rounded-[5px] p-[5px] hover:"
            >
              <img
                src={member.image}
                alt={member.name}
                className="w-32 h-32 mx-auto rounded-full object-cover mb-4"
              />
              <h4 className="font-bold">{member.name}</h4>
              <p className="text-sm text-gray-600">{member.title}</p>
            </div>
          ))}
        </div>
      </section> */}

      {/* Purpose Section */}
      {/* <section className="py-16 px-4 md:px-20 grid md:grid-cols-2 gap-10 items-center bg-white">
        <div>
          <h2 className="text-xl font-bold mb-2">
            Our Common Purpose: Creating Enjoyment for Everyone We Serve
          </h2>
          <p className="text-gray-700">
            We foster inclusive and memorable experiences for our guests and
            employees. This purpose guides everything we do at RGCC.
          </p>
        </div>
        <img
          src={
            "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754842629/DJI_20250810160323_0201_D-min_cinazs.jpg"
          }
          alt="Purpose"
          className="w-full h-auto rounded-lg"
        />
      </section> */}

      {/* 3 Steps of Service */}
      {/* <section className="bg-gray-100 py-16 px-4 md:px-20">
        <h2 className="text-2xl font-bold mb-10 text-center">
          3 Steps of Service
        </h2>
        <div className="grid md:grid-cols-3 gap-6 text-center">
          <div>
            <h3 className="text-lg font-bold mb-2">Warm Welcome</h3>
            <p>Friendly, engaging greeting to set the tone</p>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-2">Anticipate Needs</h3>
            <p>Understand and deliver on guest needs</p>
          </div>
          <div>
            <h3 className="text-lg font-bold mb-2">Safe Environment</h3>
            <p>Provide unforgettable Golf experience</p>
          </div>
        </div>
      </section> */}

      {/* Core Values */}
      {/* <section className="py-16 px-4 md:px-20 bg-white">
        <h2 className="text-2xl font-bold text-center mb-10">
          Our Core Values
        </h2>
        <div className="grid md:grid-cols-5 gap-4 text-center ">
          {["Integrity", "Fun", "Community", "Excellence", "Safety"].map(
            (val, i) => (
              <div
                key={i}
                className="border p-6 rounded-lg shadow-sm hover:shadow-md hover:bg-lime-400 transition duration-500"
              >
                <h4 className="font-bold mb-2">{val}</h4>
                <p className="text-sm text-black">
                  Core value description here
                </p>
              </div>
            )
          )}
        </div>
      </section> */}

      {/* Foundation */}
      {/* <section className="bg-lime-400 text-black py-16 px-4 md:px-20 text-center">
        <h2 className="text-xl font-bold mb-4">The RGCC</h2>
        <p className="max-w-2xl mx-auto mb-6">
          Through charitable giving, mentorship, and promoting youth golf, the
          foundation is committed to enriching lives through the game of golf.
        </p>
        <button
          onClick={() => navigate("/events")}
          className="bg-white text-black px-6 py-2 rounded hover:bg-black hover:text-white"
        >
          SEE CURRENT EVENTS
        </button>
      </section> */}

      {/* Bottom Tiles */}
      {/* <section className="py-10 px-4 md:px-20 bg-gray-100 grid md:grid-cols-3 gap-6">
        <div className="bg-white rounded-lg overflow-hidden">
          <img
            src={
              "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754934229/annie-spratt-yI3weKNBRTc-unsplash-min_fiwiyv.jpg"
            }
            alt="Weddings"
            className="w-full h-40 object-cover"
          />
          <div className="p-4">
            <h4 className="font-bold mb-2">Weddings & Events</h4>
            <p className="text-sm text-gray-600">
              Plan your special day with us
            </p>
          </div>
        </div>
        <div className="bg-white rounded-lg overflow-hidden">
          <img
            src={
              "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754934229/annie-spratt-yI3weKNBRTc-unsplash-min_fiwiyv.jpg"
            }
            alt="Membership"
            className="w-full h-40 object-cover"
          />
          <div className="p-4">
            <h4 className="font-bold mb-2">Golf Memberships</h4>
            <p className="text-sm text-gray-600">Join our golf family</p>
          </div>
        </div>
        <div className="bg-white rounded-lg overflow-hidden">
          <img
            src={
              "https://res.cloudinary.com/dxdvcplbl/image/upload/v1754934229/annie-spratt-yI3weKNBRTc-unsplash-min_fiwiyv.jpg"
            }
            alt="Shop"
            className="w-full h-40 object-cover"
          />
          <div className="p-4">
            <h4 className="font-bold mb-2">Golf Shop</h4>
            <p className="text-sm text-gray-600">
              Explore top golf gear and accessories
            </p>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default About;
